import { CONFIG_ERRORS } from '../constants'

const hasLoyalty = config => {
    return Boolean(config.loyalty)
}

const getConfigErrors = config => {
    const errors = []

    if (!config.affiliateId) {
        errors.push(CONFIG_ERRORS.AFFILIATE_ID_REQUIRED)
    }

    if (config.hasEmailCaptureCheckbox && !config.hasMultiStepCheckout) {
        errors.push(CONFIG_ERRORS.CHECKOUT.EMAIL_CAPTURE_MULTI_STEP_DEPENDENCY)
    }

    if ((config.logos || {}).desktop && !config.logos.desktop.staticImagePath) {
        errors.push(CONFIG_ERRORS.LOGOS.STATIC_IMAGE_PATH_REQUIRED)
    }

    if ((config.logos || {}).mobile && !config.logos.mobile.staticImagePath) {
        errors.push(CONFIG_ERRORS.LOGOS.STATIC_IMAGE_PATH_REQUIRED)
    }

    if (config.partnerSiteBanner && !((config.partnerSiteBanner.logos || {}).desktop || {}).staticImagePath) {
        errors.push(CONFIG_ERRORS.LOGOS.STATIC_IMAGE_PATH_REQUIRED)
    }

    if (hasLoyalty(config)) {
        if (!config.loyalty.programName) {
            errors.push(CONFIG_ERRORS.LOYALTY.PROGRAM_NAME_REQUIRED)
        }

        if (config.loyalty.isPointsEarnOnly && config.loyalty.isPointsRedeemOnly) {
            errors.push(CONFIG_ERRORS.LOYALTY.POINTS_EARN_ONLY_POINTS_REDEEM_ONLY_DEPENDENCY)
        }

        if (config.hasInsurance && !config.loyalty.isPointsEarnOnly) {
            errors.push(CONFIG_ERRORS.LOYALTY.INSURANCE_POINTS_EARN_ONLY_DEPENDENCY)
        }
    }

    if (config.merchandisingBanner) {
        if (!(config.merchandisingBanner.desktop && config.merchandisingBanner.mobile)) {
            errors.push(CONFIG_ERRORS.MERCHANDISING_BANNER.DESKTOP_AND_MOBILE_OBJECTS_REQURED)
        }

        if (!(config.merchandisingBanner.desktop || {}).staticImagePath) {
            errors.push(CONFIG_ERRORS.MERCHANDISING_BANNER.STATIC_IMAGE_PATH_REQUIRED)
        }

        if (!(config.merchandisingBanner.mobile || {}).staticImagePath) {
            errors.push(CONFIG_ERRORS.MERCHANDISING_BANNER.STATIC_IMAGE_PATH_REQUIRED)
        }
    }

    if (config.hasCustomFooterLogo && config.hasPoweredByVividSeats) {
        errors.push(CONFIG_ERRORS.LOGOS.FOOTER_LOGO_FLAGS_MUTUALLY_EXCLUSIVE)
    }

    return errors
}

const isDefaultToRedeemingLoyaltyPoints = config => {
    return hasLoyalty(config) && Boolean(config.loyalty.isPointsRedeemOnly)
}

export {
    getConfigErrors,
    hasLoyalty,
    isDefaultToRedeemingLoyaltyPoints
}
